module.exports = __webpack_public_path__ + "f8ba36736248a5f9490b313ceada3573.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/guidestone_funds.png
// module id = 1675
// module chunks = 0